import type DockingViewState from '../store/schema/DockingViewState';

export function showDockedBottom(dockingViewState: DockingViewState): boolean {
    return !dockingViewState.useStickyDocking && dockingViewState.isBottomDocking;
}

export function showStickyDockingCover(dockingViewState: DockingViewState): boolean {
    return dockingViewState?.useStickyDocking && dockingViewState.isBottomDocking;
}
